
/* ==========================================================================
   KINOVA — Qayta ishlatiladigan UI komponentlari
   Har bir funksiya HTML string qaytaradi va sahifa JS fayllarida
   (home.js, details.js, ...) container.innerHTML = KC.xxx(...) tarzida
   ishlatiladi. Backend ulanganda faqat data.js manba almashadi,
   shu fayl o'zgarishsiz qoladi.
   ========================================================================== */

(function (global) {
  var D = null; // KDATA lazy ref (DOMContentLoaded'dan keyin data.js allaqachon yuklangan bo'ladi)
  function data() { return D || (D = global.KDATA); }
  function ic(name, size) { return (global.Icon[name] || global.Icon.tag)(size); }

  /* Bosqich 4: header()/mobileMenu()/footer() D.CURRENT_USER'ni HTML'ga
     qo'shadi (foydalanuvchi ismi — ro'yxatdan o'tishda erkin matn, admin
     tomonidan kuratsiya qilinadigan MOVIES/SERIES sarlavhalaridan farqli
     o'laroq) — shuning uchun bu YERDA (va faqat shu yerda) escape qilinadi. */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Formatlash ---------------- */
  function formatViews(n) {
    if (n >= 1000000) return (Math.round((n / 1000000) * 10) / 10) + 'M';
    if (n >= 1000) return Math.round(n / 1000) + 'K';
    return String(n);
  }
  function formatDuration(min) {
    var h = Math.floor(min / 60), m = min % 60;
    return (h > 0 ? h + 's ' : '') + m + 'd';
  }
  function formatNumber(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
  function formatDate(iso) {
    if (!iso || iso === '—') return '—';
    var months = ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avg', 'sen', 'okt', 'noy', 'dek'];
    var parts = iso.split(/[- ]/);
    var y = parts[0], mo = parseInt(parts[1], 10) - 1, d = parseInt(parts[2], 10);
    return d + ' ' + months[mo] + ' ' + y;
  }

  /* ---------------- Badge / chip helperlari ---------------- */
  function ratingBadge(rating) {
    return '<span class="badge badge--rating">' + ic('starFilled', 11) + '<b>' + rating.toFixed(1) + '</b></span>';
  }
  function qualityBadge(q) {
    return '<span class="badge badge--quality">' + q + '</span>';
  }
  function genreChips(genres) {
    return '<div class="chip-row">' + genres.map(function (g) {
      var meta = data().getGenre(g);
      return '<a href="/search?genre=' + encodeURIComponent(g) + '" class="chip">' + meta.label + '</a>';
    }).join('') + '</div>';
  }
  var STATUS_MAP = {
    published: ['success', 'Chop etilgan'], draft: ['muted', 'Qoralama'], pending: ['warning', 'Kutilmoqda'],
    Active: ['success', 'Faol'], Banned: ['danger', 'Bloklangan'], Pending: ['warning', 'Kutilmoqda']
  };
  function statusBadge(status) {
    var m = STATUS_MAP[status] || ['muted', status];
    return '<span class="status-dot status-dot--' + m[0] + '">' + m[1] + '</span>';
  }
  var ROLE_MAP = { Admin: 'accent', Moderator: 'info', User: 'muted' };
  function roleBadge(role) {
    return '<span class="role-badge role-badge--' + (ROLE_MAP[role] || 'muted') + '">' + role + '</span>';
  }

  /* ---------------- Poster / Backdrop ----------------
     Rasm YO'Q bo'lsa — avvalgidek CSS-generatsiya (dizayn fallback'i).

     ⚠️ 18-bosqich: admin panel poster/fon rasmini bazaga YOZARDI, lekin
        saytga umuman uzatilmasdi va hech qachon ko'rinmasdi
        (`ContentTransformer::toItem()` ga `posterUrl`/`backdropUrl`
        qo'shildi). Bu yerda esa rasm mavjud bo'lsa `<img>` qo'yiladi.
        Tashqi `<div>` tuzilmasi va sinflari O'ZGARMADI — rasm yo'q
        holatda natija avvalgidek AYNAN bir xil bo'ladi (SSR bilan DOM
        tengligi buzilmaydi).                                          */
  function posterArt(item, extraClass) {
    var genre = item.genres && item.genres[0] ? data().getGenre(item.genres[0]) : { icon: 'film' };
    var url = item.posterUrl || '';
    return '<div class="poster-art poster-theme-' + item.theme + (extraClass ? ' ' + extraClass : '') +
      (url ? ' has-image' : '') + '">' +
      (url ? '<img class="poster-art__img" src="' + esc(url) + '" alt="' + esc(item.title || '') +
        '" loading="lazy" decoding="async">' : '') +
      '<span class="poster-art__icon">' + ic(genre.icon, 46) + '</span>' +
      '<span class="poster-art__shine"></span>' +
      '</div>';
  }
  function backdropArt(item) {
    var genre = item.genres && item.genres[0] ? data().getGenre(item.genres[0]) : { icon: 'film' };
    var url = item.backdropUrl || '';
    return '<div class="backdrop-art poster-theme-' + item.theme + (url ? ' has-image' : '') + '">' +
      (url ? '<img class="backdrop-art__img" src="' + esc(url) + '" alt="" loading="lazy" decoding="async">' : '') +
      '<span class="backdrop-art__icon">' + ic(genre.icon, 130) + '</span>' +
      '<span class="backdrop-art__title">' + esc(item.originalTitle || item.title) + '</span>' +
      '</div>';
  }

  /* ---------------- Kino / Serial kartasi ---------------- */
  function movieCard(item, opts) {
    opts = opts || {};
    var type = item.type || opts.type || 'movie';
    /* ⚠️ TUZATISH (14-bosqich): ilgari bu yerda `.html?slug=X` shim
       havolasi qurilardi va u serverda 301 (DOIMIY) yo'naltirish bilan
       `/kino/X` ga o'tardi. Brauzer 301 javobini KESHLAB qo'yadi —
       natijada qaysi kartani bosgandan qat'i nazar, birinchi bosilgan
       kino ochilib qolardi (foydalanuvchi aynan shu holatni bildirdi:
       "qaysi kinoni bosam bir xil kino chiqadi").

       Endi havola TO'G'RIDAN-TO'G'RI toza marshrutga boradi — hech
       qanday yo'naltirish yo'q, demak keshlanish muammosi ham yo'q.
       `.html` shim marshrutlari eski havolalar uchun saqlanadi. */
    var href = (type === 'series' ? '/serial/' : '/kino/') + encodeURIComponent(item.slug);
    var genreLabel = item.genres && item.genres[0] ? data().getGenre(item.genres[0]).label : '';
    var progressBar = (opts.progress != null) ? '<div class="movie-card__progress"><span style="width:' + opts.progress + '%"></span></div>' : '';
    return '' +
      '<a href="' + href + '" class="movie-card">' +
      '<div class="movie-card__poster">' +
      posterArt(item) +
      '<div class="movie-card__badges">' + qualityBadge(item.quality) + ratingBadge(item.rating) + '</div>' +
      progressBar +
      '<div class="movie-card__hover">' +
      '<span class="movie-card__play">' + ic('playCircle', 30) + '</span>' +
      '<span class="movie-card__watch">Tomosha qilish</span>' +
      '</div>' +
      '</div>' +
      '<div class="movie-card__info">' +
      '<h3 class="movie-card__title">' + esc(item.title) + '</h3>' +
      '<p class="movie-card__meta">' + item.year + ' &middot; ' + genreLabel + '</p>' +
      '</div>' +
      '</a>';
  }

  function movieRow(title, items, opts) {
    opts = opts || {};
    if (!items || !items.length) return '';
    var id = opts.id || ('row-' + Math.random().toString(36).slice(2, 9));
    var cards = items.map(function (it) { return movieCard(it, { type: opts.type }); }).join('');
    return '' +
      '<section class="row-section reveal">' +
      '<div class="row-section__head container">' +
      '<h2>' + title + '</h2>' +
      '<a href="' + (opts.seeMoreHref || '/search') + '" class="row-section__more">Barchasini ko\'rish ' + ic('arrowRight', 15) + '</a>' +
      '</div>' +
      '<div class="row-section__wrap container">' +
      '<button type="button" class="row-arrow row-arrow--left" data-scroll-target="' + id + '" data-dir="-1" aria-label="Oldingi">' + ic('chevronLeft', 19) + '</button>' +
      '<div class="row-section__scroller" id="' + id + '">' + cards + '</div>' +
      '<button type="button" class="row-arrow row-arrow--right" data-scroll-target="' + id + '" data-dir="1" aria-label="Keyingi">' + ic('chevronRight', 19) + '</button>' +
      '</div>' +
      '</section>';
  }

  function genreGrid(genres) {
    return '<div class="genre-grid">' + genres.map(function (g, i) {
      return '<a href="/search?genre=' + encodeURIComponent(g.name) + '" class="genre-card genre-card--t' + ((i % 5) + 1) + '">' +
        '<span class="genre-card__icon">' + ic(g.icon, 24) + '</span>' +
        '<span class="genre-card__name">' + g.label + '</span>' +
        '</a>';
    }).join('') + '</div>';
  }

  /* ---------------- Header / Footer / Mobile drawer ----------------
     Bosqich 4: D.CURRENT_USER orqali auth holatiga moslashadi.
     ⚠️ MEHMON (CURRENT_USER == null) tarmog'i — pastdagi 3 funksiyaning
     HAMMASIDA — asl (Bosqich 1-3) chiqishi bilan BAYT-BAYT bir xil
     qoldirilgan (vizual regressiya baseline shu holatga qurilgan).
     Faqat TIZIMGA KIRGAN holat uchun yangi shoxobcha qo'shildi. */
  function header(active) {
    function nc(key) { return active === key ? ' class="is-active"' : ''; }
    var user = data().CURRENT_USER;
    var actions = user ?
      ('<a href="/profile" class="btn btn--outline btn--sm hide-mobile">' + esc(user.name || 'Profil') + '</a>' +
       '<a href="/profile" class="icon-btn" aria-label="Profil">' + avatar(esc(user.initials || '?'), 28) + '</a>')
      :
      ('<a href="/login" class="btn btn--outline btn--sm hide-mobile">Kirish</a>' +
       '<a href="/profile" class="icon-btn" aria-label="Profil">' + ic('userCircle', 22) + '</a>');
    return '' +
      '<header class="site-header" id="siteHeader">' +
      '<div class="site-header__inner container">' +
      '<button type="button" class="icon-btn hide-desktop" id="burgerBtn" aria-label="Menyu">' + ic('menu', 22) + '</button>' +
      '<a href="/" class="brand-logo"><span class="brand-logo__mark">K</span>INOVA</a>' +
      '<nav class="site-nav hide-mobile" aria-label="Asosiy navigatsiya">' +
      '<a href="/"' + nc('home') + '>Bosh sahifa</a>' +
      '<a href="/search?type=movie"' + nc('movies') + '>Kinolar</a>' +
      '<a href="/search?type=series"' + nc('series') + '>Seriallar</a>' +
      '<a href="/search?type=cartoon"' + nc('cartoons') + '>Multfilmlar</a>' +
      '<a href="/janrlar"' + nc('genres') + '>Janrlar</a>' +
      '<a href="/top-100"' + nc('top') + '>TOP 100</a>' +
      '</nav>' +
      '<div class="site-header__actions">' +
      '<form class="header-search hide-mobile" action="/search" method="get" role="search">' +
      ic('search', 16) + '<input type="text" name="q" placeholder="Kino yoki serial qidirish...">' +
      '</form>' +
      '<button type="button" class="icon-btn hide-desktop" id="searchToggleMobile" aria-label="Qidiruv">' + ic('search', 20) + '</button>' +
      actions +
      '</div>' +
      '</div>' +
      '</header>';
  }

  function mobileMenu() {
    var user = data().CURRENT_USER;
    var footerActions = user ?
      ('<a href="/profile" class="btn btn--primary btn--block">' + esc(user.name || 'Profil') + '</a>' +
       '<a href="/profile#security" class="btn btn--ghost btn--block">' + ic('userCircle', 18) + ' Sozlamalar</a>')
      :
      ('<a href="/login" class="btn btn--primary btn--block">Kirish</a>' +
       '<a href="/profile" class="btn btn--ghost btn--block">' + ic('userCircle', 18) + ' Profil</a>');
    return '' +
      '<div class="mobile-drawer" id="mobileDrawer" aria-hidden="true">' +
      '<div class="mobile-drawer__overlay" id="mobileDrawerOverlay"></div>' +
      '<div class="mobile-drawer__panel">' +
      '<div class="mobile-drawer__top">' +
      '<a href="/" class="brand-logo"><span class="brand-logo__mark">K</span>INOVA</a>' +
      '<button type="button" class="icon-btn" id="mobileDrawerClose" aria-label="Yopish">' + ic('close', 20) + '</button>' +
      '</div>' +
      '<form class="mobile-drawer__search" action="/search" method="get">' +
      ic('search', 18) + '<input type="text" name="q" placeholder="Kino yoki serial qidirish...">' +
      '</form>' +
      '<nav class="mobile-drawer__nav">' +
      '<a href="/">' + ic('film', 18) + '<span>Bosh sahifa</span></a>' +
      '<a href="/search?type=movie">' + ic('clapperboard', 18) + '<span>Kinolar</span></a>' +
      '<a href="/search?type=series">' + ic('tv', 18) + '<span>Seriallar</span></a>' +
      '<a href="/search?type=cartoon">' + ic('palette', 18) + '<span>Multfilmlar</span></a>' +
      '<a href="/janrlar">' + ic('grid', 18) + '<span>Janrlar</span></a>' +
      '<a href="/top-100">' + ic('award', 18) + '<span>TOP 100</span></a>' +
      '</nav>' +
      '<div class="mobile-drawer__footer">' +
      footerActions +
      '</div>' +
      '</div>' +
      '</div>';
  }

  /* Bosqich 13 — ijtimoiy tarmoq havolalari SOZLAMALARDAN olinadi
     (`Setting` jadvali → bootstrap → KDATA.SETTINGS). Sozlanmagan
     tarmoq UMUMAN chiqarilmaydi — ilgari bu havolalar `href="#"` edi
     va hech qayerga bormasdi (audit topilmasi: o'lik havola). */
  /* ⚠️ 15-bosqich: YouTube belgisi `icons.js`da YO'Q va u yerga qo'shib
     ham bo'lmaydi — `resources/js/icons.js` dizayn manbasidan BAYT-BAYT
     ajratilgan va `scripts/extract-assets.mjs --check` uni qo'riqlaydi
     (`App\Support\Kdata\Icon` bilan tenglik ham shu sababli talab
     qilinadi). Shuning uchun YouTube glifi SHU YERDA, boshqa ijtimoiy
     belgilar bilan bir xil uslubda (stroke + to'ldirilgan uchburchak,
     24x24 viewBox) chiziladi. Ilgari YouTube uchun oddiy `play`
     ikonkasi ishlatilardi — foydalanuvchi haqiqiy logotip so'radi. */
  function youtubeIcon(size) {
    var s = size || 17;

    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + s + '" height="' + s +
      '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="2.2" y="5.5" width="19.6" height="13" rx="4"/>' +
      '<polygon points="10.2 9.3 15.6 12 10.2 14.7" fill="currentColor" stroke="none"/>' +
      '</svg>';
  }

  /**
   * Footer'dagi ijtimoiy tarmoq havolalari.
   *
   * ⚠️ Manzillar ADMIN PANELDAN sozlanadi: Sozlamalar bo'limidagi
   *    `social.telegram` / `social.instagram` / `social.youtube` /
   *    `social.facebook` kalitlari (SettingSeeder → Setting::public()
   *    → Catalog::all()['settings'] → window.KDATA.SETTINGS).
   *
   * ⚠️ Sozlanmagan tarmoq CHIQARILMAYDI — soxta/bo'sh havola bo'lmasin
   *    (Bosqich 13 auditi qoidasi). Ya'ni admin faqat Telegram va
   *    Instagram'ni to'ldirsa, footer'da aynan ikkita belgi ko'rinadi.
   */
  function socialLinks() {
    var s = (data().SETTINGS) || {};
    var nets = [
      ['telegram', 'Telegram'],
      ['instagram', 'Instagram'],
      ['youtube', 'YouTube'],
      ['facebook', 'Facebook']
    ];
    var html = '';

    nets.forEach(function (net) {
      var url = s['social.' + net[0]];
      if (!url) return; // Sozlanmagan — havola chiqarilmaydi.
      var glyph = net[0] === 'youtube' ? youtubeIcon(17) : ic(net[0], 17);
      html += '<a href="' + esc(url) + '" target="_blank" rel="noopener noreferrer" aria-label="' +
        net[1] + '" title="' + net[1] + '">' + glyph + '</a>';
    });

    return html ? '<div class="site-footer__social">' + html + '</div>' : '';
  }

  function footer() {
    var user = data().CURRENT_USER;
    var accountLinks = user ?
      '<a href="/profile">Profil</a><a href="/sevimlilar">Sevimlilar</a><a href="/tarix">Tomosha tarixi</a><a href="/premium">Premium</a>'
      :
      '<a href="/login">Kirish</a><a href="/register">Ro\'yxatdan o\'tish</a><a href="/premium">Premium</a>';
    return '' +
      '<footer class="site-footer">' +
      '<div class="container site-footer__grid">' +
      '<div class="site-footer__brand">' +
      '<a href="/" class="brand-logo"><span class="brand-logo__mark">K</span>INOVA</a>' +
      '<p>Premium kino va serial tomosha platformasi. Sifatli tarjima, yuqori tezlik — har doim, har joyda.</p>' +
      socialLinks() +
      '</div>' +
      '<div class="site-footer__col"><h4>Platforma</h4>' +
      '<a href="/">Bosh sahifa</a><a href="/search?type=movie">Kinolar</a><a href="/search?type=series">Seriallar</a><a href="/janrlar">Janrlar</a><a href="/top-100">TOP 100</a>' +
      '</div>' +
      '<div class="site-footer__col"><h4>Yordam</h4>' +
      '<a href="/yordam">Ko\'p so\'raladigan savollar</a><a href="/aloqa">Biz bilan aloqa</a><a href="/biz-haqimizda">Biz haqimizda</a><a href="/foydalanish-shartlari">Foydalanish shartlari</a><a href="/maxfiylik-siyosati">Maxfiylik siyosati</a>' +
      '</div>' +
      '<div class="site-footer__col"><h4>Akkaunt</h4>' +
      accountLinks +
      '</div>' +
      '</div>' +
      '<div class="site-footer__bottom container">' +
      '<p>&copy; 2026 KINOVA. Barcha huquqlar himoyalangan.</p>' +
      '</div>' +
      '</footer>';
  }

  /* ---------------- Pagination ---------------- */
  function pagination(current, totalPages) {
    if (totalPages <= 1) return '';
    var html = '<div class="pagination">';
    html += '<button type="button" class="pagination__btn" data-page="' + (current - 1) + '" ' + (current === 1 ? 'disabled' : '') + '>' + ic('chevronLeft', 15) + '</button>';
    for (var p = 1; p <= totalPages; p++) {
      html += '<button type="button" class="pagination__num' + (p === current ? ' is-active' : '') + '" data-page="' + p + '">' + p + '</button>';
    }
    html += '<button type="button" class="pagination__btn" data-page="' + (current + 1) + '" ' + (current === totalPages ? 'disabled' : '') + '>' + ic('chevronRight', 15) + '</button>';
    html += '</div>';
    return html;
  }

  /* ---------------- Avatar / Stat card / Episode card ---------------- */
  function avatar(initials, size) {
    size = size || 40;
    return '<span class="avatar" style="width:' + size + 'px;height:' + size + 'px;font-size:' + Math.round(size * 0.38) + 'px;">' + initials + '</span>';
  }

  function statCard(opts) {
    return '' +
      '<div class="stat-card">' +
      '<div class="stat-card__top">' +
      '<span class="stat-card__icon">' + ic(opts.icon, 19) + '</span>' +
      (opts.trend ? '<span class="stat-card__trend ' + (opts.trendUp ? 'is-up' : 'is-down') + '">' + ic(opts.trendUp ? 'trendingUp' : 'trendingDown', 12) + opts.trend + '</span>' : '') +
      '</div>' +
      '<div class="stat-card__value">' + opts.value + '</div>' +
      '<div class="stat-card__label">' + opts.label + '</div>' +
      '</div>';
  }

  function episodeCard(ep, seriesSlug, opts) {
    opts = opts || {};
    var progressBar = ep.progress ? '<div class="episode-card__progress"><span style="width:' + ep.progress + '%"></span></div>' : '';
    return '' +
      '<a href="/tomosha/' + seriesSlug + '?season=' + ep.season + '&episode=' + ep.number + '" class="episode-card">' +
      '<div class="episode-card__thumb poster-theme-' + ep.theme + '">' +
      '<span class="episode-card__num">' + ep.number + '</span>' +
      '<span class="episode-card__play">' + ic('playCircle', 26) + '</span>' +
      progressBar +
      '</div>' +
      '<div class="episode-card__info">' +
      '<h4>' + ep.number + '. ' + esc(ep.title) + '</h4>' +
      '<p class="episode-card__dur">' + ic('clock', 13) + formatDuration(ep.duration) + '</p>' +
      '<p class="episode-card__desc">' + esc(ep.description) + '</p>' +
      '</div>' +
      '</a>';
  }

  /* ---------------- Toast ---------------- */
  function toast(message, tone) {
    var el = document.createElement('div');
    el.className = 'toast' + (tone ? ' toast--' + tone : '');
    el.innerHTML = ic('checkCircle', 17) + '<span>' + message + '</span>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 2800);
  }

  /* ---------------- Export ---------------- */
  global.KC = {
    esc: esc,
    formatViews: formatViews,
    formatDuration: formatDuration,
    formatNumber: formatNumber,
    formatDate: formatDate,
    ratingBadge: ratingBadge,
    qualityBadge: qualityBadge,
    genreChips: genreChips,
    statusBadge: statusBadge,
    roleBadge: roleBadge,
    posterArt: posterArt,
    backdropArt: backdropArt,
    movieCard: movieCard,
    movieRow: movieRow,
    genreGrid: genreGrid,
    header: header,
    mobileMenu: mobileMenu,
    footer: footer,
    pagination: pagination,
    avatar: avatar,
    statCard: statCard,
    episodeCard: episodeCard,
    toast: toast
  };
})(window);

